module.exports = __webpack_public_path__ + "img/1f648.7581a4a.svg";